const APP_VERSION = '1.0.0';

export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          // Check for updates periodically (every 30 minutes)
          setInterval(() => registration.update(), 30 * 60 * 1000);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available — notify the user
                if (window.confirm('A new version of Doily.app is available. Reload to update?')) {
                  window.location.reload();
                }
              }
            };
          };
        })
        .catch((error) => {
          console.error('Service worker registration failed:', error);
        });
    });
  }
}
